import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: {
        path: '/',
        component: Home,
      },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },

    // ! 扎心包活动
    {
      path: '/knock',
      name: 'KnockHeart',
      component: () => import(/* webpackChunkName: "KnockHeart" */ './views/KnockHeart/index.vue'),
    },

    // ! 晚安计划活动
    {
      path: '/goodnight',
      name: 'GoodNight',
      component: () => import(/* webpackChunkName: "GoodNight" */ './views/GoodNight/index.vue'),
    },
    // ! 生活馆
    {
      path: '/lifehall',
      name: 'LifeHall',
      component: () => import(/* webpackChunkName: "LifeHall" */ './views/LifeHall/index.vue'),
    },
    {
      path: '/lifehall/slogan',
      name: 'lifehall_slogan',
      component: () => import(/* webpackChunkName: "LifeHallSlogan" */ './views/LifeHall/children/slogan.vue'),
    },
    {
      path: '/lifehall/questions',
      name: 'questions',
      component: () => import(/* webpackChunkName: "LifeHallQuestions" */ './views/LifeHall/children/questions.vue'),
    },
    {
      path: '/lifehall/poster',
      name: 'lifehall_poster',
      component: () => import(/* webpackChunkName: "LifeHallPoster" */ './views/LifeHall/children/poster.vue'),
    },
    {
      path: '/lifehall/delete',
      name: 'lifehall_delete',
      component: () => import(/* webpackChunkName: "LifeHallDel" */ './views/LifeHall/delAnswer.vue'),
    },

  ],
})
